import { render, staticRenderFns } from "./DataProductsSearch.vue?vue&type=template&id=390d2cb4&scoped=true&"
import script from "./DataProductsSearch.vue?vue&type=script&lang=js&"
export * from "./DataProductsSearch.vue?vue&type=script&lang=js&"
import style0 from "./DataProductsSearch.vue?vue&type=style&index=0&id=390d2cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d2cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390d2cb4')) {
      api.createRecord('390d2cb4', component.options)
    } else {
      api.reload('390d2cb4', component.options)
    }
    module.hot.accept("./DataProductsSearch.vue?vue&type=template&id=390d2cb4&scoped=true&", function () {
      api.rerender('390d2cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataProductsSearch.vue"
export default component.exports